import { apiClient } from './client.js';

export const notificationsApi = {
  list: (params = {}) => apiClient.get('/notifications', { params }),
  unread: () => apiClient.get('/notifications', { params: { unread: '1', per_page: 10 } }),
  markRead: (id) => apiClient.patch(`/notifications/${id}/read`),
  getPreferences: () => apiClient.get('/notifications/preferences'),
  updatePreferences: (payload) => apiClient.put('/notifications/preferences', payload),
  updateTypePreferences: (types) => apiClient.put('/notifications/preferences/types', { types }),
};
